// extracted by mini-css-extract-plugin
export default {"AddKeygiver":"AddKeyGiver_AddKeygiver__zAphV","form":"AddKeyGiver_form__wOnkL"};